<template>
    <div v-if="backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            @click="$event.target.classList.contains('modal') ? close() : true"
        >
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Generate Surat Konfirmasi Piutang</h5>
                        <button type="button" class="close" @click="close()" v-html="loadingFilter ? spin() : ic('close')"/>
                    </div>
                    <div class="modal-body default">
                        <div class="d-flex col-12 mb-4">
                            <div class="mr-2 col-4">
                                <label for="status" class="form-label">Perusahaan</label>
                                <selectize 
                                    v-model="suratTagihan.id_perusahaan" 
                                    @input="_geDepoByPerusahaan($event)"
                                    class="form-control mr-2" placeholder="Pilih Perusahaan"
                                    type="text" >
                                    <option
                                        v-for="(perusahaan, index) in form.perusahaans"
                                        :disabled="loadingFilter"
                                        :value="perusahaan.id"
                                        :key="index"
                                        required
                                    >
                                        {{ perusahaan.nama_perusahaan }}
                                    </option>
                                </selectize>
                            </div>
                          
                            <div class="mr-2 col-4">
                                <label for="status" class="form-label">Depo</label>
                                <selectize 
                                    placeholder="Pilih Depo"
                                    class="form-control mr-2"
                                    @input="resetDataToko"
                                    v-model="suratTagihan.id_depo"
                                    type="text"
                                >
                                    <option
                                        v-for="(depo, index) in form.depos"
                                        :disabled="loadingFilter"
                                        :value="depo.id"
                                        :key="index"
                                        required
                                    >
                                        {{ depo.nama_depo }}
                                    </option>
                                </selectize>
                            </div>

                            <div class="mr-2 col-4">
                                <label for="status" class="form-label">Toko</label>
                                <div class="d-flex" v-if="form.isTokoSearch" id="optionToko">
                                    <input 
                                        :disabled="suratTagihan.id_depo == ''"
                                        class="form-control m-0"
                                        placeholder="Nama Toko"
                                        v-model="form.keywordSearchToko"
                                        @keyup.enter="_getTokoByDepo"
                                        ref="optionToko"
                                    />
                                    <button 
                                        :disabled="suratTagihan.id_depo == ''"
                                        class="btn btn-white m-0"
                                        v-html="ic('search')"
                                        type="button"
                                        @click="_getTokoByDepo"
                                    ></button>
                                </div>
                               
                                <div ref="optionToko" class="d-flex" v-else>
                                    <selectize 
                                        id="optionToko"
                                        type="text" 
                                        class="form-control"
                                        @input="onTokoChange"
                                        placeholder="Pilih Toko"
                                        v-model="suratTagihan.id_toko"
                                    >
                                        <option
                                            id="optionToko"
                                            v-for="(toko, index) in form.tokos"
                                            :disabled="loadingFilter"
                                            :value="toko.id"
                                            :key="index"
                                            required
                                        >
                                            {{ toko.no_acc + " - " + toko.nama_toko }}
                                        </option>
                                    </selectize>
                                    <button 
                                        :disabled="suratTagihan.id_depo == ''"
                                        class="btn btn-white m-0"
                                        v-html="ic('keyboard')"
                                        type="button"
                                        @click="resetDataToko"
                                    ></button>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex col-12 mb-4">
                            <div class="mr-2 col-4">
                                <label for="status" class="form-label">Periode Awal</label>
                                <input
                                    type="month"
                                    class="form-control"
                                    v-model="suratTagihan.start_period"
                                    placeholder="Tanggal Surat"
                                    required
                                />
                            </div>
                            <div class="mr-2 col-4">
                                <label for="status" class="form-label">Periode Akhir</label>
                                <input
                                    type="month"
                                    class="form-control"
                                    v-model="suratTagihan.end_period"
                                    placeholder="Tanggal Surat"
                                    :min="suratTagihan.start_period"
                                    required
                                />
                            </div>
                            <div class="mr-2 col-4 d-flex">
                                <div class="mr-2 w-full">
                                    <label for="status" class="form-label">Tanggal Surat</label>
                                    <div class="d-flex">
                                        <input
                                            style="width: 60%;"
                                            type="date"
                                            class="form-control"
                                            v-model="suratTagihan.tanggal_surat"
                                            placeholder="Tanggal Surat"
                                            required
                                        />
                                        <button 
                                            style="width:40%;"
                                            :disabled="loadingFilter"
                                            @click="_searchDetailTagihan"
                                            class="btn btn-outline-primary ml-3"
                                        >
                                            Search Piutang
                                        </button>    
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loadingData" />
                        <Nodata v-if="!loadingData && form.list_invoice.length == 0" class="d-flex align-items-center justify-content-center card" style="max-height: 350px; min-height: 350px;" />

                        <div class="box" v-if="!loadingData && form.list_invoice.length > 0">
                            <div class="card table-responsive"  style="max-height: 350px; min-height: 350px;">
                                <table class=" table table-vcenter table-hover card-table table-control">
                                    <thead class="text-muted">
                                        <th>No Invoice</th>
                                        <th>Tanggal Deliver</th>
                                        <th>Tanggal Jatuh Temppo</th>
                                        <th>Total</th>
                                        <th>Sisa</th>
                                        <th >
                                            <label class="form-check" >
                                                <input 
                                                    :checked="form.list_invoice.length == form.checkeds.length"
                                                    @click="chcekUncheck"
                                                    class="form-check-input"
                                                    type="checkbox"
                                                />
                                            </label>
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detail_surat_tagihan, index) in detail_surat_tagihans" :key="index">
                                            <td>{{ detail_surat_tagihan.no_invoice }}</td>
                                            <td>{{ dFormat(`${detail_surat_tagihan.delivered_at}`, 'dmY') }}</td>
                                            <td>{{ dFormat(detail_surat_tagihan.due_date, 'dmY') }}</td>
                                            <td>{{ ribuan(detail_surat_tagihan.grand_total) }}</td>
                                            <td>{{ ribuan(detail_surat_tagihan.outstanding) }}</td>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="form.checkeds"
                                                    @input="check(detail_surat_tagihan)"
                                                    :value="detail_surat_tagihan.id_penjualan"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-end">
                                <button 
                                    class="btn btn-primary m-0"
                                    :disabled="form.checkeds.length === 0"
                                    @click="_generateSuratTagihan"
                                >
                                    Generate
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
    name: "FormGeneratePenagihan",
    props:{
        isOpen: false
    },
    data(){
        return {
            loadingFilter: false,
            loadingData: false,
            backdrop: false,
            modal: {
                open: false, 
            },
            form:{
                isTokoSearch: true,
                keywordSearchToko: '',
                perusahaans: [],
                depos: [],
                tokos: [],
                checkeds:[],
                list_invoice: []
            },
            suratTagihan:{
                id_perusahaan: '',
                id_depo: '',
                tanggal_surat: this.dateTime("ymd"),
                start_period: '',
                end_period: '',
                id_toko: '',
                surat_tagihan_details:[],
            }
        }
    },
    mixins: [helper],
    computed:{
        ...mapState('surat_tagihan', {
            detail_surat_tagihans: state => state.datas.detail,
        }),
    },
    methods: {
        ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
        ...mapActions("surat_tagihan", ["detailGenerateSuratTagihan"]),
        ...mapActions('toko', ['getListToko']),
        ...mapActions("depo", ["getListDepo"]),
        ...mapActions("surat_tagihan", ["generateSuratTagihan"]),


        async _getPerusahaan(){
            try {
                this.loadingFilter = true
                this.form.perusahaans = await this.getListPerusahaanByAccess()
            } catch (error) {
                console.log(error)
            } finally{
                this.loadingFilter = false
            }
        },
        
        async _geDepoByPerusahaan(id_perusahaan){
            try {
                this.resetDataToko()
                this.loadingFilter = true
                this.form.depos = await this.getListDepo({id_perusahaan: id_perusahaan})
            } catch (error) {
                console.log(error)
            }finally{
                this.loadingFilter = false
                setTimeout(() => {
                    if (this.form.tokos.length > 0) {
                        this.$refs.optionToko.getElementsByTagName("input")[0].focus();
                    }
                }, 50);
            }
        },  

        async _getTokoByDepo(){
            this.loadingFilter = true
            const keyword = this.form.keywordSearchToko;
            this.form.isTokoSearch = false
            try {
                this.form.tokos = await this.getListToko({id_depo: [this.suratTagihan.id_depo], keyword: keyword })
            }catch (error) {
                console.log(error)
            }finally{
                this.loadingFilter = false
            }
        },

        async _searchDetailTagihan(){
            this.loadingData = true
            const query = {
                id_perusahaan: this.suratTagihan.id_perusahaan,
                id_depo: this.suratTagihan.id_depo,
                tanggal_surat: this.suratTagihan.tanggal_surat,
                id_toko: this.suratTagihan.id_toko,
                start_period: this.suratTagihan.start_period,
                end_period: this.suratTagihan.end_period,
            }
            try {
                await this.detailGenerateSuratTagihan(query)            
            }catch (error) {
                console.log(error)
            }finally{
                this.loadingData = false
                this.form.list_invoice = this.detail_surat_tagihans
            }
        },

        _generateSuratTagihan(){
            this.$emit("generateSuratTagihan", this.suratTagihan);
            this.$emit("update:isOpen", false);
            this.resetData()
        },

        check(detail_surat_tagihan){
            const selected = detail_surat_tagihan.id_penjualan;
            const isExists = this.form.checkeds.indexOf(selected);
            if (isExists === -1) {
                this.form.checkeds.push(selected);
                this.suratTagihan.surat_tagihan_details.push(detail_surat_tagihan)
            } else {
                this.form.checkeds.splice(isExists, 1);
                this.suratTagihan.surat_tagihan_details = this.suratTagihan.surat_tagihan_details.filter(detail => detail.id_penjualan !== selected);
            }
        },

        chcekUncheck(){
            if(this.form.checkeds.length != this.form.list_invoice.length){
                this.form.checkeds = []
                this.suratTagihan.surat_tagihan_details = []
                const detailSuratTagihans = this.form.list_invoice
                this.suratTagihan.surat_tagihan_details = detailSuratTagihans
                for (let i = 0; i < detailSuratTagihans.length; i++) {
                    this.form.checkeds.push(detailSuratTagihans[i].id_penjualan)
                }
            } else{
                this.form.checkeds = []
                this.suratTagihan.surat_tagihan_details = []
            }
        },

        resetData(){
            this.suratTagihan = {
                id_perusahaan: '',
                id_depo: '',
                tanggal_surat: this.dateTime("ymd"),
                id_toko: '',
            }
            this.resetDataToko()
        },

        onTokoChange(){
            this.form.checkeds = []
            this.form.list_invoice = []
            this.suratTagihan.surat_tagihan_details = []
        },

        resetDataToko(){
            this.form.isTokoSearch = true
            this.form.keywordSearchToko = ''
            this.form.tokos = []
            this.onTokoChange()
        },

        close() {
            this.$emit("update:isOpen", false);
            this.resetDataToko()
        },
    },
    watch: {
        "isOpen": function(isOpen){
            if (isOpen) {
                this.backdrop = isOpen;
                setTimeout(() => {
                    if(this.form.perusahaans.length <= 0) this._getPerusahaan()
                    this.modal.open = isOpen;
                }, 100);
            } else {
                this.modal.open = isOpen;
                setTimeout(() => {
                    this.backdrop = isOpen;
                }, 100);
            }
        }
    }


}
</script>